import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CondominiumService, Condominium } from '../services/condominium.service';
import { UserService } from '../services/user.service';

@Component({
    selector: 'app-condominium',
    templateUrl: './condominium.component.html',
    styleUrls: ['./condominium.component.sass'],
    standalone: false
})
export class CondominiumComponent implements OnInit {
  condominiums: Condominium[] = [];

  constructor(
    private condominiumService: CondominiumService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCondominiums();
  }

  private loadCondominiums(): void {
    this.condominiumService.getCondominiums().subscribe({
      next: (condominiums) => {
        this.condominiums = condominiums;
      },
      error: (error) => {
        console.error('Error loading condominiums:', error);
      }
    });
  }

  onCondominiumClick(condominium: Condominium): void {
    this.condominiumService.isCurrentUserOwnerOfCondominium(condominium.id).then(isOwner => {
      if (isOwner) {
        this.router.navigate([`/condominium/${condominium.id}/dashboard`]);
      } else {
        this.router.navigate([`/condominium/${condominium.id}/communications`]);
      }
    });
  }

  onCreateCondominiumClick(): void {
    this.router.navigate(['/condominium/create']);
  }
} 